import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';

import { environment } from '../environments/environment';
import { iccTheme } from '../theme/icc.theme';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { credentialsInterceptor } from './core/auth/interceptors/credentials.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(
      withXhr(),
      withInterceptors([credentialsInterceptor, authInterceptor]),
    ),
    providePrimeNG({
      license: environment.primeUiLicenseKey,
      theme: {
        preset: iccTheme,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    ...provideTranslateService({
      fallbackLang: 'de',
      lang: 'de',
    }),
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json',
    }),
    provideAppInitializer(() => {
      const translate = inject(TranslateService);

      return firstValueFrom(translate.use('de'));
    }),
    MessageService,
  ],
};
